import { Icon } from '@material-ui/core';
import React from 'react';
export const renderIconDefault = name => {
  return /*#__PURE__*/React.createElement(Icon, null, name);
};
//# sourceMappingURL=icon.js.map